/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Best_CommitmentInputs */

const et_plan_best_commitment = /** @type {(inputs: Plan_Best_CommitmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ühekordne makse. Enim soovitatud.`)
};

const en_plan_best_commitment = /** @type {(inputs: Plan_Best_CommitmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`One-time payment. Most recommended.`)
};

/**
* | output |
* | --- |
* | "One-time payment. Most recommended." |
*
* @param {Plan_Best_CommitmentInputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const plan_best_commitment = /** @type {((inputs?: Plan_Best_CommitmentInputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Best_CommitmentInputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_plan_best_commitment(inputs)
	return en_plan_best_commitment(inputs)
});